import request from '@/util/request'


export const capausersAdd = (data) => request.post('/api/capausersAdd', data);  //审查委员会添加

export const capausersEdit = (data) => request.post('/api/capausersEdit', data);  //审查委员会修改

export const capausersDetail = (data) => request.post('/api/capausersDetail', data);  //审查委员会详情

export const capausersList = (data) => request.post('/api/capausersList', data);  //审查委员会列表

export const capausersDel = (data) => request.post('/api/capausersDel', data);  //审查委员会删除